export default __webpack_public_path__ + "static/media/closeBtnSquare.3c095438.svg";